import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getRides } from '../services/create-ride/api'
import useRidesStore from '../stores/rides'
import useRidesKeys from './useRidesKeys'

const useRidesQuery = () => {
  const queryClient = useQueryClient()
  const ridesKeys = useRidesKeys()
  const { page, per_page, search, from_datetime, to_datetime } = useRidesStore(state => state.searchOptions)
  const setSelectedRideId = useRidesStore(state => state.setSelectedRideId)
  const selectedRideId = useRidesStore(state => state.selectedRideId)

  return useQuery({
    refetchInterval: 15000,
    queryKey: ridesKeys,
    queryFn: async () => {
      const rides = await getRides({ page: page + 1, per_page, search, to_datetime, from_datetime })
      if (rides.rides.data.length === 0) {
        return null
      }

      const selectedRide = rides.rides.data.find(ride => ride.id === selectedRideId) || rides.rides.data[0]
      if (selectedRide.id !== selectedRideId) {
        setSelectedRideId(selectedRide.id)
      } else {
        queryClient.refetchQueries(['ride', selectedRideId])
      }
      return rides
    },
    keepPreviousData: true
  })
}

export default useRidesQuery
